"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.aiFormAnalyzer.name': 'Analizator formularzy AI',
    'tools.aiFormAnalyzer.formSentByUser': 'Wysłałem formularz.',
};
